module.exports = __webpack_public_path__ + "img/51.723f095d.png";